import React from "react"
import {Form} from "antd"
import {Select, SelectOption} from "ui"
import {CategoryData} from "../../../../types/CategoryData"
import {useTranslations} from "../hooks/use-translations"

interface Props {
  categories: CategoryData[];
}

export default function CategorySelectField({categories}: Props) {
  const t = useTranslations()

  return (
    <>
      <Form.Item name="category_id" label={t("coupons.form.category")}>
        <Select name="category_id" mode="multiple" allowClear>
          {categories?.map(category => (
            <SelectOption key={category.id} value={category.id}>{category.name}</SelectOption>
          ))}
        </Select>
      </Form.Item>
      <div className="description">
        {t("coupons.form.category.description")}
      </div>
    </>
  );
}